export default function (instance) {
    return {
        Login(payload) {
            return instance.post('/Auth/Login', payload);
        },
    }
}
